import {router} from '@netx/core-router';

export const routeToAsset = (
	id: number,
	extra = '',
	disableTrigger?: boolean,
) => router.navigate(`asset/${id}${extra ? `/${extra}` : ''}`, !disableTrigger);

export default routeToAsset;
